import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { People } from '../models/people';
import { environment } from '../../environments/environment';
import { ITeamAllocation } from '../_interfaces/teamAllocation';
import { IAssignation } from '../_interfaces/Assignation';
import { IProfileSearch } from '../_interfaces/profile-search';
import { IHeadcountStatistic } from '../_interfaces/headCountStatistic';

@Injectable({
  providedIn: 'root',
})
export class PeoplesService {
  baseUrl: string = environment.apiUrl;

  

  constructor(private HttpClient: HttpClient) {}

  get_peoples(search:IProfileSearch|null): Observable<People[]> {
    let params = new HttpParams();
    if(search){
      if (search.name) params = params.append('name', search.name);
      if (search.roleId) params = params.append('role_id', search.roleId);
      if (search.teamId) params = params.append('team_id', search.teamId);
      if (search.status) params = params.append('status', search.status);
    }
    return this.HttpClient.get<People[]>(
      this.baseUrl + '/peoples',
      { params }
    );
  }

  
  get_people(people_id: number): Observable<People> {
    return this.HttpClient.get<People>(
      this.baseUrl + '/peoples/'+people_id
    );
  }

  get_people_assignments(person: People): Observable<ITeamAllocation[]> {
    return this.HttpClient.get<ITeamAllocation[]>(
      this.baseUrl + '/peoples/'+person.id+'/assignments'
    );
  }

  update_people_assignments(person: People, assignments: IAssignation[]): Observable<ITeamAllocation[]> {
    return this.HttpClient.put<ITeamAllocation[]>(
      `${this.baseUrl}/peoples/${person.id}/assignments`,
      assignments
    );
  }

  add_people(person: People): Observable<People> {
    return this.HttpClient.post<People>(
      this.baseUrl + '/peoples',
      person
    );
  }

  update_people(person: People): Observable<People> {
    return this.HttpClient.put<People>(
      this.baseUrl + '/peoples/'+person.id,
      person
    );
  }

  delete_people(id: number): Observable<void> {
    return this.HttpClient.delete<void>(
      this.baseUrl + '/peoples/'+id
    );
  }

  getHeadcountStatistics(): Observable<IHeadcountStatistic[]> {
    return this.HttpClient.get<IHeadcountStatistic[]>(
      this.baseUrl + '/peoples/statistics/headcount'
    );
  }
  
}

